// BHP-1087: read hook for the VPS list over Backend2.0 (Hydra). The collection
// is customer-scoped by the backend (CustomerScopeExtension, BHP-1081), so it
// returns exactly the active customer's VPS rows. Replaces the legacy
// `/api/v1/.../hosting/servers` calls that hang in the Backend2.0-only stack.
//
// BHP-1260: every page, not just the first. The overview filters on the
// `server-type` label and groups per project itself, so a page-1-only list
// silently dropped every server past row 30 — a newly created one included.
import { type UseQueryResult } from '@tanstack/react-query';
import { useCollectionAll } from '../../../shared/api/useHydra';
import type { HydraCollection } from '../../../shared/api/hydra';
import type { VpsSummary } from '../domain/vpsSummary';

export function useVpsSummaries(): UseQueryResult<HydraCollection<VpsSummary>> {
  return useCollectionAll<VpsSummary>('vps');
}
